export const roles: {
  ADMINISTRATOR: '1';
  LAWYER: '2';
  CLIENT: '3';
} = {
  ADMINISTRATOR: '1',
  LAWYER: '2',
  CLIENT: '3'
}